<!--
  // FIXME: lib-client-sub-nav should not need to be added here,
  // but has been added temporarily due to rendering issues
  // with the person editor (bugs 18811 & 19060)
  // The long term solution is to render the person editor
  // inside a ng bootstrap modal
-->
<lib-client-sub-nav activeTab="Payroll"></lib-client-sub-nav>
<section class="left-nav-wrapper scroll-container d-print-none" *ngIf="render">
  <div class="d-flex">
    <div class="me-3">
      <h1 class="page-title mb-0">Payroll</h1>
    </div>
    <div class="flex-fill d-inline-flex justify-content-end">
      <button
        cpGTagEvent
        [params]="{ event_label: 'payroll_payroll_grid_cancel' }"
        class="btn btn-secondary"
        (click)="cancelPayroll()">
        Cancel Payroll
      </button>
      <button
        cpGTagEvent
        [params]="{ event_label: 'payroll_payroll_grid_preview' }"
        class="btn btn-primary ms-2"
        (click)="showBillings()"
        [disabled]="!okToPayCount || isLoading || arePaylinesCalculating()"
        [title]="isLoading ? 'Please wait while we fetch payline totals...' : ''">
        Review & Submit
      </button>
    </div>
  </div>
  <div class="row mb-4">
    <div *ngIf="payroll" class="col-10">
      <small class="row">
        <small class="col-12">
          <span class="me-3" *ngIf="payrollMgmt.periodBeginDisplay(payroll)">
            First Day of Pay Cycle:&nbsp;<strong>{{
              payrollMgmt.periodBeginDisplay(payroll)
            }}</strong>
          </span>
          <span class="me-3">
            Last Day of Pay Cycle:&nbsp;
            <strong>
              {{ payrollMgmt.periodEndDisplay(payroll) }}
            </strong>
          </span>
          <span class="me-3">
            Pay Date:&nbsp;<strong>{{
              payroll.PayDate.toString() | slice: 0 : 10 | date: 'MM/dd/yyyy'
            }}</strong>
          </span>
          <!-- FIXME/NOTE: it appears that the API returns 'NORMAL' for regular payrolls-->
          <span class="me-3" *ngIf="payroll.Label && payroll.Label != 'NORMAL'">
            Reason:&nbsp;<strong>{{ payroll.Label }}</strong>
          </span>
          <span class="me-3">
            Pay Frequency:&nbsp;<strong>{{ freqDisplay }}</strong>
          </span>
        </small>
      </small>
      <small class="row" *ngIf="dueDateWarning != null">
        <div class="col-12 text-danger">
          {{ dueDateWarning }}
        </div>
      </small>
    </div>
    <div id="lastSavedBy" class="col-2">
      <div *ngIf="isLoading" class="text-center pe-3 pt-1">
        <i class="fas fa-2x fa-circle-notch fa-spin"></i>
        <div>Loading...</div>
      </div>
      <div
        *ngIf="!isLoading && payroll"
        class="d-flex flex-row-reverse text-end align-items-center">
        <i class="fas fa-3x fa-save ms-2"></i>
        <small>
          <div>{{ payroll.LastEditBy }}</div>
          <strong>{{ payroll.LastEditOn | date: 'MM/dd/yyyy h:mma' }}</strong>
        </small>
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-between align-items-end">
    <div style="line-height: 3">
      <div style="line-height: 1">
        <small>
          <strong>{{ rowFilterIndicator }}</strong>
        </small>
      </div>
      <div class="btn-group btn-group-toggle me-4" role="group" aria-label="Payline View Controls">
        <button
          class="btn btn-secondary row-view-btn rounded-start"
          (click)="onRowViewChange('all')">
          All
        </button>
        <button class="btn btn-secondary row-view-btn" (click)="onRowViewChange('changed')">
          Changed
        </button>
        <button class="btn btn-secondary row-view-btn" (click)="onRowViewChange('warnings')">
          Warnings
        </button>
        <button
          class="btn btn-secondary row-view-btn rounded-end"
          (click)="onRowViewChange('errors')">
          Errors
        </button>
      </div>
      <small>
        <a class="cp-green" (click)="showPaylineErrors(content)">View Errors</a>
      </small>
    </div>
    <input
      type="text"
      class="form-control mb-1"
      [(ngModel)]="searchValue"
      placeholder="Search..."
      style="max-width: 250px; height: 43px; margin-right: 100px" />

    <div class="d-flex flex-column align-items-end">
      <div style="line-height: 1">
        <small>
          <strong>{{ columnVizIndicator }}</strong>
        </small>
      </div>
      <div
        ngbDropdown
        #customizeDrop="ngbDropdown"
        display="dynamic"
        class="d-inline"
        placement="bottom-right"
        style="line-height: 3">
        <button
          cpGTagEvent
          [params]="{ event_label: 'payroll_payroll_grid_columns' }"
          class="btn btn-secondary"
          style="padding: 5px 10px"
          ngbDropdownToggle>
          Columns
          <i class="fas fa-th"></i>
        </button>
        <div ngbDropdownMenu>
          <div class="container" style="width: max-content; line-height: 1.6">
            <div class="float-end">
              <button
                cpGTagEvent
                [params]="{ event_label: 'payroll_payroll_grid_columns_dropdown_close' }"
                type="button"
                class="close d-print-none"
                aria-label="Close"
                (click)="customizeDrop.close()">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="mt-0">Toggle Columns</div>
            <hr class="mt-1 mb-1" />
            <div class="d-flex" style="max-height: 500px; overflow-y: auto; min-width: 150px">
              <ul class="toggle-col-ul ps-0">
                <li *ngFor="let col of toggleableColumns">
                  <input
                    class="small"
                    type="checkbox"
                    id="{{ col.field }}-checkbox"
                    value="true"
                    [checked]="!col.hide"
                    (change)="toggleColumn(col.field, null)" />
                  <label for="{{ col.field }}-checkbox"
                    ><span></span>&nbsp;
                    <small>
                      {{ col.headerName }}
                    </small>
                  </label>
                </li>
              </ul>
              <ul class="toggle-col-ul">
                <li
                  *ngIf="earningsGroup && earningsGroup.children && earningsGroup.children.length">
                  <input
                    class="small"
                    type="checkbox"
                    id="earnings-grp-checkbox"
                    value="true"
                    (change)="toggleColumnGroup($event, 'Earnings')"
                    checked="checked" />
                  <label for="earnings-grp-checkbox"
                    ><span></span>&nbsp;<small><strong>Earnings</strong></small></label
                  ><br />
                  <ul class="toggle-col-ul">
                    <li *ngFor="let e of earningsGroup.children; let i = index">
                      <!--
                      bug 15306. Make sure that there is always at least one column which remains visible.
                      This is done by disabling the toggle on the last remaining visible column
                    -->
                      <input
                        class="small"
                        type="checkbox"
                        id="{{ e.field }}-grp-checkbox"
                        value="true"
                        [checked]="!e.hide"
                        (change)="toggleColumn(e.field, 'Earnings')"
                        [disabled]="isColumnFilterDisabled(e, 'Earnings')" />
                      <label for="{{ e.field }}-grp-checkbox"
                        ><span></span>&nbsp;
                        <small>
                          {{ e.headerName }}
                          <i
                            *ngIf="e.headerComponentParams && e.headerComponentParams.icon"
                            class="{{ e.headerComponentParams.icon }}">
                          </i>
                        </small>
                      </label>
                    </li>
                  </ul>
                </li>
              </ul>
              <ul class="toggle-col-ul">
                <li
                  *ngIf="
                    deductionsGroup && deductionsGroup.children && deductionsGroup.children.length
                  ">
                  <input
                    class="small"
                    type="checkbox"
                    id="deductions-grp-checkbox"
                    value="true"
                    (change)="toggleColumnGroup($event, 'Deductions')"
                    checked="checked" />
                  <label for="deductions-grp-checkbox"
                    ><span></span><small><strong>&nbsp;Deductions</strong></small></label
                  ><br />
                  <ul class="toggle-col-ul">
                    <!--
                    bug 15306. Make sure that there is always at least one column which remains visible.
                    This is done by disabling the toggle on the last remaining visible column
                  -->
                    <li *ngFor="let d of deductionsGroup.children; let i = index">
                      <input
                        class="small"
                        type="checkbox"
                        id="{{ d.field }}-grp-checkbox"
                        value="true"
                        [checked]="!d.hide"
                        (change)="toggleColumn(d.field, 'Deductions')"
                        [disabled]="isColumnFilterDisabled(d, 'Deductions')" />
                      <label for="{{ d.field }}-grp-checkbox"
                        ><span></span>&nbsp;
                        <small>
                          {{ d.headerName }}
                          <i
                            *ngIf="d.headerComponentParams && d.headerComponentParams.icon"
                            class="{{ d.headerComponentParams.icon }}">
                          </i>
                        </small>
                      </label>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ag-grid-angular
    [ngStyle]="{ height: gridHeight }"
    style="max-height: 625px"
    class="ag-theme-alpine"
    [rowData]="rowData"
    (cellKeyDown)="onCellKeyDown($event)"
    [columnDefs]="columnDefs"
    [columnTypes]="columnTypes"
    [singleClickEdit]="true"
    [gridOptions]="gridOptions"
    [quickFilterText]="searchValue"
    [rowClassRules]="rowClassRules"
    [tooltipShowDelay]="0"
    [enableBrowserTooltips]="true"
    [stopEditingWhenCellsLoseFocus]="true"
    [suppressDragLeaveHidesColumns]="true">
  </ag-grid-angular>
</section>
<ng-template #content let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Payline Errors</h4>
    <button
      cpGTagEvent
      [params]="{ event_label: 'payroll_payroll_grid_errors_modal_dismiss' }"
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div *ngIf="!paylineErrors.length"><em>No payline errors...</em></div>
    <div class="d-flex flex-row-reverse" *ngIf="paylineErrors.length">
      <a class="cp-green d-print-none" (click)="print()">
        <small>Print <i class="fas fa-print"></i></small>
      </a>
    </div>
    <table id="payline-errors-table" class="table" *ngIf="paylineErrors.length">
      <thead class="d-print-none">
        <tr>
          <th
            class="sort"
            (click)="sortPaylineErrors($event, 'payline-errors-table', 'WarningLevel')">
            Type
          </th>
          <th class="sort" (click)="sortPaylineErrors($event, 'payline-errors-table', 'Id')">Id</th>
          <th class="sort" (click)="sortPaylineErrors($event, 'payline-errors-table', 'Name')">
            Name
          </th>
          <th>Message</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let error of paylineErrors">
          <td class="{{ error.WarningLevel }}-bg">{{ error.WarningLevel }}</td>
          <td>{{ error.Id }}</td>
          <td>{{ error.FirstName + ' ' + error.LastName }}</td>
          <td class="text-wrap">{{ error.Message }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</ng-template>
<ng-container *ngIf="showPaylineDetails">
  <payline-detail-editor
    [args]="paylineDetailArgs"
    [payroll]="payroll"
    [earningConfigs]="earningConfigs"
    [deductionConfigs]="deductionConfigs"
    [taxConfigs]="taxConfigs"
    [employeePay]="selEmployeePay"
    [initialState]="initialPaylineState"
    (onCloseDetails)="closePaylineDetails($event)"
    (onOpenLaborAllocations)="onAllocationClick({ rowData: $event })">
  </payline-detail-editor>
</ng-container>
<!-- payline errors table just for printing -->
<h4 class="d-none d-print-table">Payline Errors for {{ clientCode }}</h4>
<table
  id="payline-errors-print-table"
  class="table d-none d-print-table"
  *ngIf="paylineErrors.length">
  <thead>
    <tr>
      <th>Type</th>
      <th>Id</th>
      <th>Name</th>
      <th>Message</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let error of paylineErrors">
      <td class="{{ error.WarningLevel }}-bg">{{ error.WarningLevel }}</td>
      <td>{{ error.Id }}</td>
      <td>{{ error.FirstName + ' ' + error.LastName }}</td>
      <td class="text-wrap">{{ error.Message }}</td>
    </tr>
  </tbody>
</table>
<add-person-to-payroll [employeeStatuses]="employeeStatuses"> </add-person-to-payroll>
<ng-container *ngIf="showPersonEditor" class="person-editor-modal">
  <person-editor-payroll-modal
    [personId]="selPersonId"
    [clientCode]="clientCode"
    (onCloseEditor)="closePersonEditor($event)"
    [employeePay]="selEmployeePay"
    [payDate]="payroll.PayDate"
    [periodEnd]="payroll.Calendars[0].PeriodEnd"
    [year]="year"
    [seqNo]="seqNo">
  </person-editor-payroll-modal>
</ng-container>
